<template>
    <div>
        <popover v-if="isShowing" width="300px" height="200px" @close="abort">
            <div class="body">
                <div class="content">
                    <c-input title="Passwort:" v-model="messageOut" labelWidth="80px" :forceFocus="true" type="textarea"></c-input>
                    <message class="message" v-if="!ConnectionState" type="hint" size="xs" :text="$t('text.errorNoServerConnection')"></message>
                </div>
                <div class="footer">
                    <c-button @click="abort" type="link-button" class="important" :label="$t('text.abort')"></c-button>
                    <c-button @click="send" :disabled="!ConnectionState" class="important" :label="$t('text.send')"></c-button>
                </div>
            </div>
        </popover>
        <div v-if="hasMessageIn" class="toast">
            <div class="f-row toast-header"><div>{{$t('text.message')}}</div><div class="close" @click="removeAll"></div></div>
            <div v-for="m in getMessages" :key="m.id">{{m.msg}}</div>
        </div>
    </div>
</template>

<script>

import { mapMutations, mapActions, mapGetters } from 'vuex';

import Popover from './Popover.vue';
import Message from './Message.vue'
import CInput from './CInput.vue'
import CButton from './CButton.vue'

import glAct from '../store/actions/global';
import glMut from '../store/mutations/global';

export default {
    name: "WkbHelp",
    data: function() {
        return {
            messageOut: '',
            messageIn: [],
            msgId: 0,
            request: (message, HeatGuid) => {
                if(!HeatGuid || HeatGuid === this.HeatGuid) {
                    const m = {
                        id: this.msgId,
                        msg: message,
                        show: true,
                        type: this.$i18n.t('text.global'),
                    }
                    if(!!HeatGuid) 
                        m.type = this.SelectedHeat.eventName;
                        
                    this.messageIn.unshift(m);
                    if(!!this.ToastTime){
                        window.setTimeout((id) => {
                            this.messageIn.find(m => m.id === id).show = false;
                        }, this.ToastTime, this.msgId);
                    }
                    this.msgId++;
                }
            },
        }
    },
    methods:{
        ...mapMutations([
            glMut.SETWKBHELP,
            glMut.REGISTERHUB,
            glMut.UNREGISTERHUB
        ]),
        ...mapActions([
            glAct.SENDWKBHELP
        ]),  
        send(){
            this.SENDWKBHELP(this.messageOut);
            this.SETWKBHELP(false);
            this.messageOut = '';
        },
        abort(){
            this.SETWKBHELP(false);
        },
        removeAll(){
            this.messageIn.forEach(m => m.show = false);
        },
    },
    computed:{
        ...mapGetters(['ConnectionState', 'WKBHelp', 'HeatGuid', 'SelectedHeat', 'ToastTime']), 
        isShowing(){
            return this.WKBHelp;
        },
        hasMessageIn() {
            const m = this.messageIn.filter(m => m.show===true);
            return m && m.length !== 0;
        },
        getMessages() {
            return this.messageIn.filter(m => m.show===true);
        }
    },
    components: {
        Popover,
        Message,
        CInput,
        CButton,
    },
    created(){
        var RegisterMethods = () => {
            this.REGISTERHUB({
                name: "ReceiveMessage",
                method: this.request
            });
        }

        if(this.Connection != ""){
            RegisterMethods();
        }

        this.$store.subscribe((mutation, state) => {
            if(mutation.type == glMut.SETCONNECTION && state.glModule.connection != ""){
                RegisterMethods();
            }
        });
    },
    beforeDestroy(){
        this.UNREGISTERHUB({
                name: "ReceiveMessage",
                method: this.request
        });
    }
}
</script>

<style lang="scss" scoped>

    @import "../../assets/styles/_globals";

    .toast {
        background-color:$toast-bg;
        position: absolute;
        right: 10px;
        top: 10px;
        z-index: 100;
        padding: 10px;
        border-radius: 5px;
        min-width:150px;
        max-width:90%;

        .close {
            margin-left: auto;
        }

        .close::after {
            font: normal normal normal 30px "Material Design Icons";
            content: "\F0156";
            cursor: pointer;
        }

        > div {
            border-top: 1px solid;
        }

        > div:first-of-type {
            border-top: none;
            > div {
                font-size:25px;
                font-weight: bold;
                line-height: 30px;;
            }
        }
    }

    .body {
        @extend %f-column;
        padding: $spacer_s;
        height: 100%;
        box-sizing: border-box;
    }

    .content {
        @extend %f-column;
        @extend %f-grow;
    }
    
    .footer {
        padding-top:10px;
        text-align: right;
    }

</style>